import { Component, OnInit } from '@angular/core';
import { ConfigService } from 'src/app/core/services/config.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})

/**
 * Footer Component
 */
export class FooterComponent implements OnInit {

  year: number = new Date().getFullYear();
  version: string = '';
  copyrightBy: string = 'Nuvoll';

  constructor(private configService: ConfigService) { }

  ngOnInit(): void {
    this.configService.getConfigValue('SISTEMA', 'VERSION').subscribe((v: string) => this.version = v);
    this.configService.getConfigValue('SISTEMA', 'COPYRIGHT_BY').subscribe((v: string) => this.copyrightBy = v);
  }

}
